import { IntegrationCard } from '~/components/IntegrationCard';
import { useIntegration } from '~/hooks/useIntegration';
import { Slack } from 'lucide-react';

// HubSpot logo as inline SVG
const HubSpotIcon = () => (
  <svg viewBox="0 0 24 24" className="h-7 w-7" fill="#FF7A59">
    <path d="M17.83 11.21V8.15a2.12 2.12 0 0 0 1.23-1.91v-.06A2.13 2.13 0 0 0 16.93 4.05h-.06a2.13 2.13 0 0 0-2.13 2.13v.06c0 .82.47 1.53 1.16 1.88v3.1a5.16 5.16 0 0 0-2.42 1.2l-6.4-4.98a2.57 2.57 0 0 0 .07-.56 2.6 2.6 0 1 0-2.6 2.6c.44 0 .86-.11 1.22-.31l6.27 4.88a5.18 5.18 0 0 0-.15 1.22 5.2 5.2 0 0 0 5.2 5.2 5.2 5.2 0 0 0 5.2-5.2 5.2 5.2 0 0 0-4.46-5.15zm-1 7.83a2.68 2.68 0 1 1 0-5.36 2.68 2.68 0 0 1 0 5.36z" />
  </svg>
);

// Attio logo as inline SVG
const AttioIcon = () => (
  <svg viewBox="0 0 24 24" className="h-7 w-7" fill="#000000">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 15.5v-3.07c-1.16-.41-2-1.52-2-2.83 0-1.66 1.34-3 3-3s3 1.34 3 3c0 1.31-.84 2.42-2 2.83V17.5h-2zm1-7.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
  </svg>
);

const SlackIcon = () => <Slack className="h-7 w-7 text-[#611f69]" />;

export const IntegrationSettings = () => {
  const hubspot = useIntegration('hubspot');
  const attio = useIntegration('attio');
  const slack = useIntegration('slack');

  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Integrations</h1>
        <p className="text-muted-foreground mt-1">
          Connect third-party services to sync form submissions automatically.
        </p>
      </div>

      <div className="max-w-2xl space-y-6">
        <div className="space-y-3">
          <h2 className="text-lg font-semibold">CRM</h2>
          <div className="grid gap-4">
            <IntegrationCard
              name="HubSpot"
              description="Sync form submissions as Contacts and Companies in HubSpot CRM."
              icon={<HubSpotIcon />}
              connected={hubspot.connected}
              connectedBy={hubspot.integration?.connected_by}
              connectedAt={hubspot.integration?.created_at}
              loading={hubspot.loading}
              error={hubspot.error}
              onConnect={hubspot.connect}
              onDisconnect={hubspot.disconnect}
            />
            <IntegrationCard
              name="Attio"
              description="Sync form submissions as People and Companies in Attio CRM."
              icon={<AttioIcon />}
              connected={attio.connected}
              connectedBy={attio.integration?.connected_by}
              connectedAt={attio.integration?.created_at}
              loading={attio.loading}
              error={attio.error}
              onConnect={attio.connect}
              onDisconnect={attio.disconnect}
            />
          </div>
        </div>

        <div className="space-y-3">
          <h2 className="text-lg font-semibold">Notifications</h2>
          <div className="grid gap-4">
            <IntegrationCard
              name="Slack"
              description="Notify a Slack channel when someone partially completes a form."
              icon={<SlackIcon />}
              connected={slack.connected}
              connectedBy={slack.integration?.connected_by}
              connectedAt={slack.integration?.created_at}
              loading={slack.loading}
              error={slack.error}
              onConnect={slack.connect}
              onDisconnect={slack.disconnect}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
